import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { daysFromNow } from '@zapier/date';

import { useIsAuthenticated } from '@zapier/design-system-revenue/src/hooks';

import { professionalTrialBanner as ProfessionalTrialBannerQuery } from './types/professionalTrialBanner';

export const useProfessionalTrialBannerQuery = gql`
  query professionalTrialBanner($accountId: Int!, $interval: BillingInterval!) {
    account(id: $accountId) {
      id
      trialEndDate
    }

    nextPlan: nextPlanV2(accountId: $accountId, interval: $interval) {
      amount
      id
      interval
      name
    }
  }
`;

export type Props = {
  skip?: boolean;
};

export const useData = ({ skip }: Props = {}) => {
  const { isAuthenticated } = useIsAuthenticated();
  const accountId = localStorage.getItem('currentAccountId');

  const { data, loading, error } = useQuery<ProfessionalTrialBannerQuery>(
    useProfessionalTrialBannerQuery,
    {
      skip: skip || !isAuthenticated || !accountId,
      variables: {
        accountId: parseInt(accountId ?? ''),
        interval: 'year',
      },
    }
  );

  const nextPlan = data?.nextPlan;
  const trialEndDate = data?.account.trialEndDate;

  return {
    error: error
      ? 'There was an error fetching account information. Please try again.'
      : null,
    isLoading: loading,
    nextPlan: nextPlan
      ? {
          interval: nextPlan.interval,
          monthlyAmount:
            nextPlan.interval === 'year'
              ? nextPlan.amount / 12
              : nextPlan.amount,
          name: nextPlan.name,
        }
      : undefined,
    trialDaysRemaining: trialEndDate ? daysFromNow(trialEndDate) : 0,
  };
};
